class AdTemplate {

    constructor($rootScope) {

    	var _self = this;
        this.$rootScope = $rootScope;

        return {
            restrict: 'E',
            template: "<div class='tpl-item'><img ng-src='https://storage.googleapis.com/assets-scenestealer-210713/creatives/{{template.urn}}/thumbnail.png' class='builder-template'><div><button type='button' class='btn btn-default' ng-click='selectTemplate(template)'>Select</button><h5>{{template.name}}</h5></div></div>",
            replace: true,
            scope: {
            	"template": "="
            },
            link: ($scope, $el, $attr) => {

            	_self.$scope = $scope;
            	_self.$el = $el;

                $scope.selectTemplate = (t) => _self.selectTemplate.call(_self, t);


            }             
        };

    }

    selectTemplate(template) {
        this.$rootScope.$broadcast("select-template", template);
    }


}

angular.module('cpm')
    .directive('adTemplate', ['$rootScope', ($rootScope) => {
        'use strict';
        return new AdTemplate($rootScope);
    }]);
